const getCycleCardAuthorName = (cycle) => {
  if (cycle) {
    const {
      createdBy: { name = "" },
    } = cycle;
    const [firstName, lastName] = name.toUpperCase().split(" ");
    return {
      fullName: name,
      firstName,
      lastName,
    };
  } else {
    return {
      fullName: "",
      firstName: "",
      lastName: "",
    };
  }
};

export default getCycleCardAuthorName;
